module.exports = __webpack_public_path__ + "static/media/bus.caee5ecc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/bus.pdf
// module id = 2051
// module chunks = 0